// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"9a00f33d","742":"bfc0593e","928":"e66ae000"}[chunkId] + ".chunk.js";
};